import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './PlaylistCall.styl';
import {browserHistory} from 'react-router';
import CoachingPlan from 'records/CoachingPlan';
import CoachingTodo from 'records/CoachingTodo';
import './PlaylistCallHint.styl';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import CoachingReview from 'records/CoachingReview';
import User from 'records/User';
import pluralize from 'pluralize';

export default class PlaylistCallHint extends React.PureComponent {
  constructor(props) {
    super(props);
    this.navigateOrFlash = this.navigateOrFlash.bind(this);
  }

  navigateOrFlash() {
    const {onCallsTab, plan} = this.props;
    if (onCallsTab) {
      CoachingPlaylistActions.triggerFlash();
    } else {
      browserHistory.push({
        pathname: '/calls',
        state: {rep: plan.recipient.info},
      });
    }
  }

  render() {
    const {todo} = this.props;

    if (todo.done === undefined) {
      // It's the default prop => still loading.
      // Return null to avoid flashing different messages.
      return null;
    }

    return (
      <div
        onClick={this.navigateOrFlash}
        className={classNames('playlist-call-hint pointer', {
          done: todo.callsToAdd === 0,
        })}>
        {<div>Click "Add to Plan" on the calls tab</div>}
        {todo.callsToAdd > 0 && (
          <div>
            You need to add {todo.callsToAdd} more {pluralize('call', todo.callsToAdd)}.
          </div>
        )}
      </div>
    );
  }
}

PlaylistCallHint.propTypes = {
  noCallAllowed: PropTypes.bool,
  onCallsTab: PropTypes.bool,
  plan: PropTypes.instanceOf(CoachingPlan),
  review: PropTypes.instanceOf(CoachingReview),
  sessionUser: PropTypes.instanceOf(User),
  todo: PropTypes.instanceOf(CoachingTodo),
};
